import { render, staticRenderFns } from "./no-image.vue?vue&type=template&id=1f554cd7&scoped=true&"
import script from "./no-image.vue?vue&type=script&lang=ts&"
export * from "./no-image.vue?vue&type=script&lang=ts&"
import style0 from "./no-image.vue?vue&type=style&index=0&id=1f554cd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f554cd7",
  null
  
)

export default component.exports